( function($) {
    $(document).ready(function() {

        // console.log('sc p tag fix');
        var p = $('.shortcode p:empty');
        $.each(p, function(){
            // console.log('p');
            $(this).remove();
        });


    })
}(jQuery));
